
import WkFormItem from './WkFormItem';

export default {
  // 多块形式的form-item 用于字段库
  name: 'WkFormItems',

  components: {
    WkFormItem: WkFormItem
  },

  props: {
    // 表单验证前缀
    propPrefix: {
      type: String,
      default: ''
    },
    fieldFrom: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fieldList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 忽略的字段直接输出
    ignoreFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: Boolean
  },

  data: function data() {
    return {};
  },


  computed: {},

  watch: {},

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    fieldChange: function fieldChange(item, index, value, valueList) {
      this.$emit('change', item, index, value, valueList);
    }
  }
};